/* global $:true */
import debug from "debug";
import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '.product-detail';
const PLUGIN_NAME = 'productDetail';
const MODULE_NAME = 'app.core/modules/registration-form';
const log = debug(MODULE_NAME);
const PRICE_CONTAINER_SELECTOR = '[data-product-detail-price]';

log('registerd');

class ProductDetail {

	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.$element = $(element);

		this.$lengthField = $(this.options.lengthField);
		this.$lengthFieldWrapper = $(this.options.lengthFieldWrapperId);
		this.$productDetailOptionGroups = $(this.options.productDetailOptionGroups);
		this.$priceContainer = $(PRICE_CONTAINER_SELECTOR);

		this.lengthVal = '';
		this.codeVal = '';
		this.watch();

		log('construct', element);

	}

	lengthFieldChange() {
		this.lengthVal = this.$lengthField.val();
		this.codeVal = typeof(this.$lengthFieldWrapper.attr(this.options.productCode)) == 'undefined' ? '' : this.$lengthFieldWrapper.attr(this.options.productCode);
		this.skuVal = typeof(this.$lengthFieldWrapper.attr(this.options.sku)) == 'undefined' ? '' : this.$lengthFieldWrapper.attr(this.options.sku);
		this.postLengthFieldValue();
	}

	postLengthFieldValue() {
		const url = `${this.options.endpointUrl}?${this.options
			.endpointParam}=${this.codeVal}&${this.options
			.endpointParam2}=${this.lengthVal}&${this.options
				.endpointParam3}=${this.skuVal}`;

		var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();

		log('accepting', this.$element, url);
		$.ajax({
			url,
			method: 'post',
			data: {
				__RequestVerificationToken: token
			},
			success: result => {
				this.$priceContainer.empty().append(result);
			},
			error: e => {
				log('setProductDetailLengthAjaxError', e);
			}
		}).done(() => {
			log('accepted', this.$element, url);
		});
	}

	getProductDetailScrollCookie() {
		var cname = this.options.productDetailScrollCookieName;
	    var name = cname + "=";
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var ca = decodedCookie.split(';');
	    for(var i = 0; i <ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}

	deleteProductDetailScrollCookie() {
		var cname = this.options.productDetailScrollCookieName;
		document.cookie = cname+'=; Max-Age=-99999999;';
	}

	watch() {
		this.$lengthField.on('change', this.lengthFieldChange.bind(this));
	}

	unwatch() {
		this.$lengthField.off('change');

		log('unbound', this.$element);
	}
}

ProductDetail.DEFAULTS = {
	lengthField : '[name="length"]',
	endpointParam: 'code',
	endpointParam2: 'length',
	endpointParam3: 'sku',
	endpointUrl: $(`meta[name="site.setProductDetailLengthApiEndpoint"]`).attr('content'),
	productCode : 'data-product-code',
	sku: 'data-sku',
	productDetailScrollCookieName : 'str001.ProductDetailScrollPosition',
	lengthFieldWrapperId : '#product-detail-length'
};

plugin(PLUGIN_NAME, ProductDetail);

export function exec () {
  $(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();

  });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/product-detail/index.js